<template>
  <div id="restore-password">
    <div class="container">
      <div class="row">
        <div class="col-md-6 col-md-offset-3">
          <div class="login">
            <h2 class="section-title">Restore Password</h2>
            <div class="alert alert-success" v-if="topMessage">
              <span>{{ topMessage }}</span>
            </div>
            <form>
              <div :class="[email ? 'show-label' : '', 'form-group']">
                <label>Email</label>
                <input type="text" class="form-control" placeholder="Email" v-model="email" />
                <h6 class="text-danger small" v-if="emailError">{{ emailError }}</h6>
              </div>
              <div class="form-group">
                <b-button variant="primary" class="pull-left" @click="restore($event)">Restore</b-button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapState} from 'vuex'

  export default {
    name: 'restore-password',
    data () {
      return {
        email: null,
        emailError: null,
        topMessage: null
      }
    },
    computed: {
      ...mapState({
        token: state => state.token,
        user: state => state.user
      })
    },
    created () {
      if (this.token) {
        this.$router.push({ name: 'homepage' })
      }
    },
    methods: {
      restore (e) {
        e.preventDefault()

        this.$store.dispatch('LoadingOn')
        this.$store.dispatch('RestorePassword', {
          email: this.email
        })
          .then(() => {
            this.emailError = null
            this.topMessage = 'An email has been sent to your inbox. Please follow the process to restore your password.'
            this.$store.dispatch('LoadingOff')
          })
          .catch(error => {
            console.log(error)
            this.emailError = error.errors.email ? error.errors.email.join(' ') : null
            this.$store.dispatch('LoadingOff')
          })
      },
      notifyVue (type, message) {
        this.$notifications.notify({
          message: message,
          icon: '',
          horizontalAlign: 'right',
          verticalAlign: 'bottom',
          type: type
        })
      }
    }
  }

</script>



// WEBPACK FOOTER //
// restore-password.vue?67c0f57e